module.exports = __webpack_public_path__ + "components/forecast-table/static/freezing-graph_backdrop-1d61303505ee17d3d95650864808eb28.jpg";